import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';

/**
 * Guard für die `/auth/*`-Routen.
 *
 * Lässt anonyme User durch und schickt bereits eingeloggte User auf die
 * Root-Route (Dashboard-Resolver entscheidet, welche Shell — Customer
 * oder Admin — anschließend gemountet wird).
 *
 * Idiom (Sprint 4 S4-20): Functional-Guard returned `UrlTree`, statt
 * `router.navigate(...)` als Side-Effect zu rufen. Vermeidet Race-Conditions
 * mit dem Router-Lifecycle und matched die offizielle Angular-Empfehlung
 * für Functional Guards.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.user()?.token) {
    return router.createUrlTree(['/']);
  }
  return true;
};
